module.exports = __webpack_public_path__ + "assets/img/4e64-de.svg";